import { Box } from '@/components/grid';
import { MinicartListing } from '@/components/similar-but-safer/components/minicart-listing';
import { QuickCompareHeader, ListingsGrid } from './styles';
import { useEffect, useState } from 'react';
import { type VehicleSearchResult } from '@tac/vehicle-api-client/types';
import { VehicleSearchResultSchema } from '@tac/vehicle-api-client/schemas';

type Props = {
  vehicle: VehicleSearchResult;
};
export const MinicartListings = ({ vehicle }: Props) => {
  const [similarButSafer, setSimilarButSafer] = useState<VehicleSearchResult[]>([]);

  useEffect(() => {
    const fetchSimilarButSafer = async () => {
      const response = await fetch('/api/similar-but-safer', {
        body: JSON.stringify(vehicle),
        method: 'POST',
      }).then((r) => r.json());
      const parsed = VehicleSearchResultSchema.array().safeParse(response);
      if (parsed.success) {
        setSimilarButSafer(parsed.data);
      }
    };

    fetchSimilarButSafer();
  }, [setSimilarButSafer, vehicle]);

  if (similarButSafer.length === 0) {
    return null;
  }

  return (
    <Box>
      <QuickCompareHeader as="h2">Quick compare</QuickCompareHeader>
      <ListingsGrid>
        {similarButSafer.slice(0, 3).map((hit, index) => (
          <MinicartListing key={hit.vehicleid} vehicle={hit} column={index + 1} />
        ))}
      </ListingsGrid>
    </Box>
  );
};
